var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listComponent',{attrs:{"merchant-products":_vm.merchantProducts,"service-category":_vm.serviceCategory,"type":"service","tableCheckboxShow":true}})}
var staticRenderFns = []

export { render, staticRenderFns }